export default __webpack_public_path__ + "static/media/Customization.7afd74cb.png";